import React, {Component} from 'react';
import {connect} from 'react-redux';
import {groupBy, map, cloneDeep} from 'lodash';
import {Modal, Button, Radio, Form, TextArea} from 'semantic-ui-react';
import {transportTypes} from '../../../../common/dictionaries/classification';
import {Actions} from '../../../../common/actions';
import {getOrderAmount} from './utils';

class GenerateTxtModal extends Component {
  constructor(props) {
    super(props);
    const availableTransportOptions = this.getAvailableTransportOptions();
    this.state = {
      'modalWasOpen': false,
      'authorizationReason': '',
      'transportOptionSelected': Object.keys(availableTransportOptions).length === 2 ?
        this.getTransportAvailable(availableTransportOptions) : '',
    };
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.handleTransportChange = this.handleTransportChange.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
    this.onGenerateTxtClick = this.onGenerateTxtClick.bind(this);
    this.handleAskForAuthorizationClick = this.handleAskForAuthorizationClick.bind(this);
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {providersOrdersList} = this.props;
    if (prevProps.providersOrdersList === providersOrdersList) {
      return;
    }

    const availableTransportOptions = this.getAvailableTransportOptions();
    if (Object.keys(availableTransportOptions).length === 1) {
      const transportAvailable = this.getTransportAvailable(availableTransportOptions);
      this.setState({'transportOptionSelected': transportAvailable});
    }
  }

  handleReasonChange(event, data) {
    this.setState({'authorizationReason': data.value});
  }

  handleTransportChange(event, data) {
    this.setState({'transportOptionSelected': data.value});
  }

  onCloseModalClick() {
    this.setState({
      'modalWasOpen': false,
      'authorizationReason': '',
    });
  }

  handleAskForAuthorizationClick() {
    const {providerId, orderType} = this.props;
    const {transportOptionSelected, authorizationReason} = this.state;
    const availableTransportOptions = this.getAvailableTransportOptions();
    const orders = cloneDeep(availableTransportOptions[transportOptionSelected]);
    const ordersUpdatedStatus = this.replaceStatusInOrders(orders);
    const orderList = this.getOrderSelectedItems(ordersUpdatedStatus, transportOptionSelected);
    const data = {
      'provider': providerId,
      'orderType': orderType,
      'shipmentOrder': transportOptionSelected,
      'orders': orderList,
      'authorizationDescription': authorizationReason,
    };
    this.props.onCloseDetailCard();
    this.props.askForProviderSpecialOrderAuthorization(data);
    this.onCloseModalClick();
  }

  getAvailableTransportOptions() {
    const {providersOrdersList} = this.props;
    const selectedOrders = providersOrdersList.filter((element) => element.transport === 'M' || element.checked);
    return groupBy(selectedOrders, 'transport');
  }

  getTransportAvailable(availableTransportOptions) {
    const transports = Object.keys(availableTransportOptions);
    return transports[0];
  }

  getSelectedStatus(element, transport) {
    const maritime = 'M';
    if (transport === maritime) {
      return true;
    }
    return element.checked;
  }

  getOrderSelectedItems(orderList, transport) {
    return orderList.filter((element) => this.getSelectedStatus(element, transport));
  }

  getAuthorizationStatus() {
    const {transportOptionSelected} = this.state;
    const {totalLimit, totalValue, providersOrdersList} = this.props;
    const maritimeTransport = 'M';
    const orderAmount = getOrderAmount(providersOrdersList, transportOptionSelected);

    return !!transportOptionSelected && transportOptionSelected !== maritimeTransport &&
      ((totalValue + orderAmount) > totalLimit);
  }

  renderReasonInput() {
    const {authorizationReason} = this.state;

    if (!this.getAuthorizationStatus()) {
      return null;
    }

    return (
      <Form>
        <label><strong>Motivo para la autorización</strong></label>
        <TextArea value={authorizationReason} onChange={this.handleReasonChange} />
      </Form>
    );
  }

  renderProcessButtons() {
    const {transportOptionSelected, authorizationReason} = this.state;

    if (this.getAuthorizationStatus()) {
      const isDisabled = !authorizationReason || authorizationReason.length < 5;

      return (
        <Button primary
          content='PEDIR AUTORIZACION'
          disabled={!transportOptionSelected || isDisabled}
          onClick={this.handleAskForAuthorizationClick}
        />
      );
    }

    return (
      <Button primary
        content='GENERAR'
        disabled={!transportOptionSelected}
        onClick={this.onGenerateTxtClick}
      />
    );
  }

  renderTransportOptions() {
    const availableTransportOptions = this.getAvailableTransportOptions();

    return transportTypes.map((option, index) => {
      return (
        <div key={index}>
          <Radio
            label={option.text}
            name='radioGroup'
            value={option.value}
            disabled={!availableTransportOptions[option.value] ||
              !availableTransportOptions[option.value].length}
            checked={this.state.transportOptionSelected === option.value}
            onChange={this.handleTransportChange}
          />
        </div>
      );
    });
  }

  fetchData() {
    this.setState({'modalWasOpen': true});
  }
  
  onGenerateTxtClick() {
    const {providerId, orderType} = this.props;
    const {transportOptionSelected} = this.state;
    const availableTransportOptions = this.getAvailableTransportOptions();
    const orders = cloneDeep(availableTransportOptions[transportOptionSelected]);
    const ordersUpdatedStatus = this.replaceStatusInOrders(orders);
    const orderList = this.getOrderSelectedItems(ordersUpdatedStatus, transportOptionSelected);
    const data = {
      'provider': providerId,
      'orderType': orderType,
      'shipmentOrder': transportOptionSelected,
      'orders': orderList,
    };
    this.props.onCloseDetailCard();
    this.props.generateTxtForProviderSpecialOrders(data);
    this.onCloseModalClick();
  }

  replaceStatusInOrders(orders) {
    return map(orders, (item) => {
      if (item.status) {
        item.status = 'G';
      }
      return item;
    });
  }

  render() {
    const {modalWasOpen} = this.state;
    const {disabled} = this.props;

    return (
      <Modal size='small' onOpen={() => this.fetchData()}
        className='checking-modal'
        open={modalWasOpen}
        trigger={
          <Button primary
            className='toyota-primary'
            disabled={disabled}
            content='GENERAR TXT'
          />
        }>

        <Modal.Header>
          Generar Pedido Especial
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>
            <div className=''>
              <strong>Seleccione la vía:</strong>
            </div>
            {this.renderTransportOptions()}
            {this.renderReasonInput()}
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button onClick={this.onCloseModalClick.bind(this)}>
            CANCELAR
          </Button>
          {this.renderProcessButtons()}
        </Modal.Actions>

      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'providersOrdersList': state.providerOrdersList.list,
    'totalLimit': state.providerOrdersControl.totalLimit,
    'totalValue': state.providerOrdersControl.totalValue,
  };
};

const {
  generateTxtForProviderSpecialOrders,
  askForProviderSpecialOrderAuthorization,
} = Actions;

export default connect(mapStateToProps, {
  generateTxtForProviderSpecialOrders,
  askForProviderSpecialOrderAuthorization,
})(GenerateTxtModal);
